import { render } from "./BoxHeaderEmpresas.vue?vue&type=template&id=7a947cf0"
import script from "./BoxHeaderEmpresas.vue?vue&type=script&lang=js"
export * from "./BoxHeaderEmpresas.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__